// extracted by mini-css-extract-plugin
export default {"page":"page_page__Fe6oH","small":"page_small__OmLPx","large":"page_large__gfYzk"};